export default (value, radix = 0) => {
    if (!value) return value;
    return parseFloat(value, radix);
};